var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2564_88962)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 44,
    height: 44,
    rx: 9.67033,
    fill: "#EB6F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2778 44.5V39.6111C10.2778 34.211 14.6555 29.8333 20.0556 29.8333H27.3889C28.739 29.8333 29.8334 28.7389 29.8334 27.3889V27.3889C29.8334 26.0389 28.739 24.9444 27.3889 24.9444H17.6112C13.5611 24.9444 10.2778 21.6612 10.2778 17.6111V17.6111C10.2778 13.561 13.5611 10.2778 17.6112 10.2778H24.9445C27.6446 10.2778 29.8334 8.08895 29.8334 5.38889V5.38889V0.5",
    stroke: "#EEEAD7",
    strokeWidth: 3.66667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1666 44.5V39.6111V39.6111C15.1666 36.9111 17.3554 34.7222 20.0555 34.7222H27.3888C31.4389 34.7222 34.7222 31.439 34.7222 27.3889V27.3889C34.7222 23.3388 31.4389 20.0556 27.3888 20.0556H17.6111C16.261 20.0556 15.1666 18.9611 15.1666 17.6111V17.6111C15.1666 16.2611 16.261 15.1667 17.6111 15.1667H24.9444C30.3445 15.1667 34.7222 10.789 34.7222 5.38889V0.5",
    stroke: "#EEEAD7",
    strokeWidth: 3.66667
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2564_88962"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 44,
    height: 44,
    rx: 9.67033,
    fill: "#EEEAD7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMobile);
export default __webpack_public_path__ + "static/media/logo-mobile.5d7732f1760b5d3305fcc67463cb9000.svg";
export { ForwardRef as ReactComponent };